<template>
<div>
    <div class="news-reel" v-if="!loading" @mouseenter="doPause(true)" @mouseleave="doPause(false)">
        <marquee-text :duration="80" :paused="paused">
            <a v-for="entry in entries" :key="'news-entry-'+entry.id" :href="entry.permalink" target="_BLANK">{{entry.title}}</a>
        </marquee-text>
    </div>
    <div v-else class="loader">
        <div class="row">
            <div class="col-12"><div class="loader-text pb-4 mb-1"></div></div>
        </div>
    </div>
</div>
</template>
 
<script>
export default {
    data () {
        return {
            entries : [],
            loading : true,
            timer : null,
            paused : false
        }
    },
    methods: {
        loadEntries(){
            axios.get("/api/feed/notiunionEntries/").then(({ data }) => {
                this.entries = data.data; this.loading = false;
            });
        },
        doPause(value){
            this.paused = value;
        }
    },
    mounted() {
        this.timer = setInterval(function(){
            this.loadEntries();
        }.bind(this), 30 * 60 * 1000);
    },
    created() {
        this.loadEntries();
    },
    beforeDestroy() {
        if(this.timer) clearInterval(this.timer);
    },
    watch: {
        entries(){
            this.$forceUpdate();
        }
    }
}
</script>